/* ============================================================
   IsLoved theme — vanilla JS runtime
   Mega-menu, mobile drawer, cart drawer + AJAX, toast,
   quantity steppers, predictive search, scroll-snap dots.
   No framework; progressive-enhancement first.
   ============================================================ */
(function () {
  'use strict';

  var routes = window.ilRoutes || {};
  var strings = window.ilStrings || {};

  /* ---------- helpers ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatMoney(cents) {
    var fmt = window.ilMoneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, value)
             .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  /* ---------- focus trap ---------- */
  function trapFocus(container, firstFocus) {
    var focusables = $all('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])', container);
    if (!focusables.length) return function () {};
    var first = firstFocus || focusables[0];
    var last = focusables[focusables.length - 1];
    function handler(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', handler);
    (first).focus();
    return function () { container.removeEventListener('keydown', handler); };
  }

  var scrollLockCount = 0;
  function lockScroll() { scrollLockCount++; document.documentElement.style.overflow = 'hidden'; }
  function unlockScroll() { scrollLockCount = Math.max(0, scrollLockCount - 1); if (!scrollLockCount) document.documentElement.style.overflow = ''; }

  /* ============================================================
     Generic drawer controller (mobile menu + cart drawer)
     ============================================================ */
  function Drawer(el) {
    if (!el) return null;
    var releaseFocus = null;
    var lastTrigger = null;
    var api = {
      el: el,
      isOpen: function () { return el.classList.contains('is-open'); },
      open: function (trigger) {
        lastTrigger = trigger || document.activeElement;
        el.classList.add('is-open');
        el.setAttribute('aria-hidden', 'false');
        lockScroll();
        var panel = $('.il-drawer__panel', el) || el;
        releaseFocus = trapFocus(panel);
      },
      close: function () {
        el.classList.remove('is-open');
        el.setAttribute('aria-hidden', 'true');
        unlockScroll();
        if (releaseFocus) { releaseFocus(); releaseFocus = null; }
        if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
      },
      toggle: function (trigger) { this.isOpen() ? this.close() : this.open(trigger); }
    };
    // Delegate on the persistent drawer container so close still works after the panel
    // is replaced with fresh HTML (e.g. the cart re-renders on add-to-bag).
    on(el, 'click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-drawer-close]') || (t.classList && t.classList.contains('il-drawer__scrim'))) {
        api.close();
      }
    });
    on(document, 'keydown', function (e) { if (e.key === 'Escape' && api.isOpen()) api.close(); });
    return api;
  }

  /* ============================================================
     Header: mega-menu (hover + focus + keyboard)
     ============================================================ */
  function initMegaMenu() {
    var items = $all('[data-mega-item]');
    var openTimer = null;
    items.forEach(function (item) {
      var trigger = $('[data-mega-trigger]', item);
      var panel = $('[data-mega-panel]', item);
      if (!trigger || !panel) return;

      function open() {
        clearTimeout(openTimer);
        items.forEach(function (o) { if (o !== item) close(o); });
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
      function close(target) {
        var t = target || item;
        t.classList.remove('is-open');
        var tr = $('[data-mega-trigger]', t);
        if (tr) tr.setAttribute('aria-expanded', 'false');
      }
      on(item, 'mouseenter', open);
      on(item, 'mouseleave', function () { openTimer = setTimeout(function () { close(); }, 120); });
      on(trigger, 'focus', open);
      on(trigger, 'click', function (e) {
        // allow keyboard/tap toggle without leaving immediately
        if (item.classList.contains('is-open') && !e.detail) { return; }
      });
      on(item, 'focusout', function (e) {
        if (!item.contains(e.relatedTarget)) close();
      });
      on(trigger, 'keydown', function (e) {
        if (e.key === 'Escape') { close(); trigger.focus(); }
        if (e.key === 'ArrowDown') { e.preventDefault(); open(); var first = $('a', panel); if (first) first.focus(); }
      });
    });
  }

  /* ============================================================
     Mobile menu drawer + accordion groups
     ============================================================ */
  function initMobileMenu() {
    var drawerEl = $('#il-mobile-drawer');
    if (!drawerEl) return;
    var drawer = Drawer(drawerEl);
    $all('[data-mobile-menu-open]').forEach(function (b) {
      on(b, 'click', function () { drawer.open(b); });
    });
    $all('[data-accordion-toggle]', drawerEl).forEach(function (btn) {
      on(btn, 'click', function () {
        var group = btn.closest('[data-accordion]');
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        if (group) group.classList.toggle('is-open', !expanded);
      });
    });
    window.ilMobileDrawer = drawer;
  }

  /* ============================================================
     Cart drawer + AJAX cart
     ============================================================ */
  var cartDrawer = null;
  function initCartDrawer() {
    var el = $('#il-cart-drawer');
    if (el) cartDrawer = Drawer(el);
    var drawerEnabled = document.body.getAttribute('data-cart-drawer') !== 'false';

    $all('[data-cart-open]').forEach(function (b) {
      on(b, 'click', function (e) {
        if (cartDrawer && drawerEnabled) { e.preventDefault(); cartDrawer.open(b); }
      });
    });
  }

  function refreshCartUI(cart) {
    // update header counts
    $all('[data-cart-count]').forEach(function (n) {
      n.textContent = cart.item_count;
      n.classList.toggle('is-empty', cart.item_count === 0);
    });
    $all('[data-cart-count-bubble]').forEach(function (n) {
      n.hidden = cart.item_count === 0;
      n.textContent = cart.item_count;
    });
  }

  function fetchAndRenderDrawer() {
    var el = $('#il-cart-drawer');
    if (!el) return Promise.resolve();
    return fetch(routes.cart_url + '?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#il-cart-drawer .il-drawer__panel');
        var current = el.querySelector('.il-drawer__panel');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        bindCartLineEvents();
      })
      .catch(function () {});
  }

  function bindCartLineEvents() {
    var el = $('#il-cart-drawer');
    if (!el) return;
    $all('[data-line-change]', el).forEach(function (input) {
      on(input, 'change', function () {
        changeLine(input.getAttribute('data-line'), parseInt(input.value, 10));
      });
    });
    $all('[data-line-step]', el).forEach(function (btn) {
      on(btn, 'click', function () {
        var line = btn.getAttribute('data-line');
        var dir = parseInt(btn.getAttribute('data-line-step'), 10);
        var input = el.querySelector('[data-line="' + line + '"][data-line-change]');
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + dir);
        changeLine(line, next);
      });
    });
    $all('[data-line-remove]', el).forEach(function (btn) {
      on(btn, 'click', function () { changeLine(btn.getAttribute('data-line'), 0); });
    });
  }

  function changeLine(line, quantity) {
    fetch(routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        refreshCartUI(cart);
        fetchAndRenderDrawer();
        // also refresh the cart page if we're on it
        if (document.body.classList.contains('template-cart')) window.location.reload();
      });
  }

  function addToCart(form, opts) {
    opts = opts || {};
    var formData = new FormData(form);
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    return fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
        if (!res.ok) { showToast(res.data.description || res.data.message || 'Could not add to bag', true); return; }
        return fetch(routes.cart_url + '.js').then(function (r) { return r.json(); }).then(function (cart) {
          refreshCartUI(cart);
          /* No success toast — the cart drawer opening already conveys the add. (Error toast above stays.) */
          return fetchAndRenderDrawer().then(function () {
            if (cartDrawer && document.body.getAttribute('data-cart-drawer') !== 'false' && opts.openDrawer !== false) {
              cartDrawer.open(btn);
            }
          });
        });
      });
  }

  function initProductForms() {
    $all('form[action*="/cart/add"]').forEach(function (form) {
      on(form, 'submit', function (e) {
        e.preventDefault();
        addToCart(form, {});
      });
    });
  }

  /* ---------- toast ---------- */
  var toastTimer = null;
  function showToast(msg, isError) {
    var t = $('#il-toast');
    if (!t) return;
    t.textContent = (msg ? (msg + (isError ? '' : ' — ' + (strings.addedToBag || 'added to your bag'))) : (strings.addedToBag || 'Added to your bag'));
    if (isError) t.textContent = msg;
    t.classList.toggle('is-error', !!isError);
    t.hidden = false;
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      t.classList.remove('is-visible');
      setTimeout(function () { t.hidden = true; }, 300);
    }, 1900);
  }

  /* ============================================================
     Quantity steppers (PDP + cart page)
     ============================================================ */
  function initQuantitySteppers() {
    $all('[data-qty]').forEach(function (wrap) {
      var input = $('input', wrap);
      $all('[data-qty-step]', wrap).forEach(function (btn) {
        on(btn, 'click', function () {
          var dir = parseInt(btn.getAttribute('data-qty-step'), 10);
          var min = parseInt(input.min, 10) || 1;
          var next = Math.max(min, (parseInt(input.value, 10) || min) + dir);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ============================================================
     Scroll-snap rails — dot indicators
     ============================================================ */
  function initSnapRails() {
    $all('[data-snap-rail]').forEach(function (rail) {
      var dotsWrap = rail.parentNode.querySelector('[data-snap-dots]');
      if (!dotsWrap) return;
      var slides = $all(':scope > *', rail);
      dotsWrap.innerHTML = '';
      slides.forEach(function (_, i) {
        var d = document.createElement('button');
        d.className = 'il-dot';
        d.setAttribute('aria-label', 'Go to item ' + (i + 1));
        /* Scroll only the rail — scrollIntoView would also nudge the window vertically. */
        on(d, 'click', function () {
          var sl = slides[i];
          var delta = sl.getBoundingClientRect().left - rail.getBoundingClientRect().left;
          rail.scrollTo({ left: rail.scrollLeft + delta - (rail.clientWidth - sl.offsetWidth) / 2, behavior: reduceMotion ? 'auto' : 'smooth' });
        });
        dotsWrap.appendChild(d);
      });
      var dots = $all('.il-dot', dotsWrap);
      function update() {
        var center = rail.scrollLeft + rail.clientWidth / 2;
        var active = 0, min = Infinity;
        slides.forEach(function (s, i) {
          var c = s.offsetLeft + s.clientWidth / 2;
          var dist = Math.abs(c - center);
          if (dist < min) { min = dist; active = i; }
        });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === active); });
      }
      on(rail, 'scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      update();
    });
  }

  /* ============================================================
     Predictive search (header)
     ============================================================ */
  function initPredictiveSearch() {
    var wrap = $('[data-predictive-search]');
    if (!wrap || !routes.predictive_search_url) return;
    var input = $('input[type="search"]', wrap) || $('input[name="q"]', wrap);
    var results = $('[data-predictive-results]', wrap);
    if (!input || !results) return;
    var debounce;
    on(input, 'input', function () {
      var q = input.value.trim();
      clearTimeout(debounce);
      if (q.length < 2) { results.hidden = true; results.innerHTML = ''; return; }
      debounce = setTimeout(function () {
        var url = routes.predictive_search_url + '?q=' + encodeURIComponent(q) +
                  '&resources[type]=product,collection,article,page&resources[limit]=6&section_id=predictive-search';
        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('[data-predictive-inner]');
            results.innerHTML = inner ? inner.innerHTML : '';
            results.hidden = false;
          })
          .catch(function () { results.hidden = true; });
      }, 220);
    });
    on(document, 'click', function (e) { if (!wrap.contains(e.target)) results.hidden = true; });
    on(input, 'keydown', function (e) { if (e.key === 'Escape') { results.hidden = true; } });
  }

  /* ---------- expose for sections ---------- */
  window.ilTheme = {
    addToCart: addToCart,
    showToast: showToast,
    openCart: function (t) { if (cartDrawer) cartDrawer.open(t); },
    refreshCartUI: refreshCartUI,
    fetchAndRenderDrawer: fetchAndRenderDrawer
  };

  /* ---------- boot ---------- */
  function init() {
    initMegaMenu();
    initMobileMenu();
    initCartDrawer();
    bindCartLineEvents();
    initProductForms();
    initQuantitySteppers();
    initSnapRails();
    initPredictiveSearch();
  }
  if (document.readyState === 'loading') on(document, 'DOMContentLoaded', init);
  else init();
})();
